import createSpinner from "../../../Shared/Functions/createSpinner";
import { standardGridPageSize } from "../../../Shared/GlobalVariables/filterVariables";

export default /*@ngInject*/ function ($http, $uibModalInstance, helperService, dataItemRecords, selectedColumns, selectedProduct, uniqueValues, modify, existingTickets) {

    const vm = this;

    vm.$onInit = onInit;

    vm.existingTickets = existingTickets;
    vm.tickets = [...existingTickets];
    vm.dataItemRecords = dataItemRecords;
    vm.selectedColumns = selectedColumns;
    vm.selectedProduct = selectedProduct;
    vm.uniqueItems = uniqueValues;
    vm.modify = modify;

    vm.saveTickets = saveTickets;
    vm.linkTicket = linkTicket;
    vm.checkExistingTickets = checkExistingTickets;
    vm.updateTicket = updateTicket;
    vm.removeTicket = removeTicket;
    vm.dismiss = dismiss;

    function onInit() {
        vm.ticketsToRemove = [];
        vm.dataItem = [...vm.dataItemRecords];

        let keyFields = vm.selectedColumns.map(column => column.field);
        let extracted = vm.dataItemRecords.map(object => {
            let response = keyFields.map(element => {
                return { [element]: object[element] };
            });

            object = Object.assign({}, ...response);    

            return object;
        });
        vm.extractedItems = extracted.unique();
        vm.dataItemRecords = { items: [], auditLogTicket: false };

        if (vm.selectedProduct) {
            vm.dataItemRecords.ProductId = vm.selectedProduct.ID;
            vm.dataItemRecords.ProductType = vm.selectedProduct.Type;
        } else {
            vm.dataItemRecords.auditLogTicket = true;
        }

        vm.dataItemRecords.items = vm.dataItemRecords.items.concat(vm.dataItem);

        vm.AtHeaderIds = vm.uniqueItems.map(item => item.ChangeHeaderId);

        defineSelectedItemsGrid();
    }

    function checkExistingTickets() {
        if (modify) {
            tickets.forEach(ticket => updateTicket(ticket));
        }
    }

    function updateTicket(ticket) {
        if (vm.tickets.every(item => item.TicketId !== ticket.TicketId)) {
            vm.tickets.push(ticket);
        }
    }

    function removeTicket(providerString) {
        vm.tickets = vm.tickets.filter(ticket => ticket.TicketProvider !== providerString);

        vm.ticketsToRemove.push(vm.dataItem.find(item => item.TicketProvider === providerString));
    }

    function defineSelectedItemsGrid() {
        vm.selectedItemsGridOptions = helperService.setMainGridOptions(vm.selectedColumns, null);
        vm.selectedItemsGridOptions.selectable = false;
        vm.selectedItemsGridOptions.autoBind = true;
        vm.selectedItemsGridOptions.filterable = false;

        vm.selectedItemsGridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: async options => {
                    try {
                        options.success(vm.extractedItems);
                    } catch {
                        options.error();
                    }
                }
            }
        });
    }

    async function saveTickets() {
        vm.actionInProgress = new createSpinner();

        // Link selected header ids to each ticket
        try {
            vm.tickets.forEach(async ticket => {
                if (ticket !== vm.existingTickets.find(existingTicket => existingTicket.TicketId === ticket.TicketId)) {
                    await linkTicket(ticket);
                }
            });

            if (vm.ticketsToRemove.length) {
                vm.ticketsToRemove.forEach(async ticket => {
                    await unLinkRecord(ticket.AtHeaderTicketId);
                });
            }

            await helperService.successfulSaveButton(vm.actionInProgress);
            $uibModalInstance.close();
        } catch {
            vm.actionInProgress.loadingValue = false;
            return;
        }
    }

    async function linkTicket(ticket) {
        const productType = vm.dataItemRecords.ProductType;

        let postData = {
            "TicketId": ticket.TicketId,
            "Provider": ticket.TicketProvider
        }

        postData.AtHeaderIds = vm.AtHeaderIds;
        postData.ProductId = vm.dataItemRecords.ProductId;
        postData.ProductType = productType;

        try {
            await $http.post(apiUrl + 'api/audittrail/tickets', postData);

            if (productType === 'OR' || productType === 'AX7' || productType === 'SAP') {
                await buildHeaderPost(productType, vm.uniqueItems);
            }
        } catch (response) {
            helperService.showErrorMessage(response.data);
            return;
        }
    }

    async function buildHeaderPost(productType, dataItems) {
        let headerPostData = { "Tickets": [] };
        let headerEndpoint = '';

        dataItems.forEach(dataItem => {
            if (productType === 'OR') {
                headerPostData.Tickets.push({
                    "RecId": dataItem.RecId,
                    "ChangeDate": dataItem.ChangeDate,
                    "Template": dataItem.Template,
                    "TableName": dataItem.TableName,
                    "Event": dataItem.Event,
                    "UserName": dataItem.User,
                    "Responsibility": dataItem.Responsibility,
                    "Application": dataItem.Application
                });

                headerEndpoint = 'api/audittrail/or/tickets';
            }
            else if (productType === 'AX7') {
                headerPostData.Tickets.push({
                    "RecId": dataItem.RecId,
                    "ObjRecId": dataItem.ObjRecId,
                    "ModifiedOn": dataItem.ModifiedOn,
                    "TableName": dataItem.TableName,
                    "Event": dataItem.Event,
                    "Description": dataItem.Description,
                    "ModifiedBy": dataItem.ModifiedBy
                });

                headerEndpoint = 'api/audittrail/ax7/tickets';
            }
            else if (productType === 'SAP') {
                headerPostData.Tickets.push({
                    "ChangeNumber": dataItem.ChangeNumber,
                    "Template": dataItem.Template,
                    "ChangeDate": dataItem.ChangeDate,
                    "TableName": dataItem.TableName,
                    "Event": dataItem.Event,
                    "UserName": dataItem.User
                });

                headerEndpoint = 'api/audittrail/sap/tickets';
            }
        });

        try {
            await $http.post(apiUrl + headerEndpoint, headerPostData);
        } catch (response) {
            helperService.showErrorMessage(response.data);
            vm.actionInProgress = false;
        }
    }

    async function unLinkRecord(headerTicketId) {
        try {
            await $http.delete(`${apiUrl}api/audittrail/tickets/${headerTicketId}`);
        } catch (response) {
            helperService.showErrorMessage(response.data);
        }
    }

    function dismiss() {
        if (modify) {
            $uibModalInstance.close();
        } else {
            $uibModalInstance.dismiss();
        }
    }
}